import { render, staticRenderFns } from "./DocumentNew.vue?vue&type=template&id=72d00f97&scoped=true"
import script from "./DocumentNew.vue?vue&type=script&lang=js"
export * from "./DocumentNew.vue?vue&type=script&lang=js"
import style0 from "./DocumentNew.vue?vue&type=style&index=0&id=72d00f97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d00f97",
  null
  
)

export default component.exports